import React, { useEffect, useState } from "react";
import Banner from "../components/banner";
import { contacts_req } from "../api/api";
import { useSelector } from "react-redux";
import Popup from "../components/popup";
import { useIntl } from "react-intl";

import SimpleSlider from "../components/simpleSlider";
import MapComponent from "../components/map";
import LocationWhiteIcon from "../assets/images/icons/location-white-icon.png";
import EnvelopWhiteIcon from "../assets/images/icons/envelop-white-icon.png";
import PhoneWhiteIcon from "../assets/images/icons/phone-white-icon.png";
import CloseDarkIcon from "../assets/images/icons/close-dark-icon.png";
import CheckGreenIcon from "../assets/images/icons/checked-green.png";
import Head from "next/head";

const Contact = () => {
  const intl = useIntl();

  const [state, setState] = useState({
    name: "",
    email: "",
    description: "",
    phone: "",
  });
  const [error, setError] = useState(null);
  const [nameError, setNameError] = useState(null);
  const [descriptionError, setDescriptionError] = useState(null);
  const [phoneError, setPhoneError] = useState(null);
  const contactData = useSelector((state) => state.main.contacts);
  const [successSave, setSuccessSave] = useState(false);
  const [hostName, setHostName] = useState(null);
  const country = useSelector((state) => state.main?.data?.country);
  const countryCode = String(country);

  const handleChange = (evt) => {
    const value = evt.target.value;

    setState({
      ...state,
      [evt.target.name]: value,
    });
  };

  const windowHost = async () => {
    const data = await window.location.hostname;
    setHostName(data);
  };
  useEffect(() => {
    windowHost();
  }, []);

  const addContacts = async () => {
    const name = state.name;
    const email = state.email;
    const phone = state.phone;
    const description = state.description;

    function validateEmail(email) {
      const re = /\S+@\S+\.\S+/;
      return re.test(email);
    }

    const reData = validateEmail(email);
    if (phone.length < 1) {
      setPhoneError(intl.messages.phoneRequired);
    } else {
      setPhoneError("");
    }
    if (name.length < 1) {
      setNameError(intl.messages.nameRequired);
    } else {
      setNameError("");
    }
    if (description.length < 1) {
      setDescriptionError(intl.messages.messageRequired);
    } else {
      setDescriptionError("");
    }
    if (!reData) {
      setError(intl.messages.emailRequired);
    } else {
      setError("");
    }
    if (name.length > 1 && reData && description.length > 1) {
      try {
        const addContactsData = await contacts_req(state);
        if (addContactsData.success) {
          setSuccessSave(!successSave);
          setError("");
        }
      } catch (e) {
        if (e.response.data) {
          setError(e.response.data?.message);
        }
      }
    }
  };

  const closeSuccessPopup = () => {
    setSuccessSave(!successSave);
    setState({
      name: "",
      email: "",
      description: "",
    });
  };
  //   const meta = useMemo(() => {
  //     return {
  //       title: ,
  //       description:
  //         "Ցանկանում ես գնել բնական փայտից  կոնյակի տակառ, ժամացույց, շախմատ, նարդի, ձեռնափայտ և այլ հուշանվերներ | Իմացիր ավելին այստեղ",
  //     };
  //   }, []);
  return (
    <>
      <Head>
        <title>{intl.messages.contactUs_title}</title>
        <meta
          name="description"
          content={intl.messages.contactUs_desc}
        />
        {/* Other meta tags */}
      </Head>
      <div className="contact">
        <Banner
          title={intl.messages.contact}
          currentPage={intl.messages.contactUs}
        />
        <div className="wrapper">
          <div className="contact-content flex flex-ai-center">
            <div className="contact-info">
              <ul>
                <li className="flex flex-ai-center">
                  <div className="icon flex flex-ai-center flex-jc-center">
                    <img
                      src={PhoneWhiteIcon.src}
                      alt=""
                    />
                  </div>

                  {hostName === "handle.ge" && (
                    <>
                      {countryCode === "2" && (
                        <a href="tel:+79965377770">+79965377770</a>
                      )}
                      {(countryCode === "3" || countryCode === "0") && (
                        <div>
                          <span>{intl.messages.phone}</span>

                          <a href="tel:+995593152339">+995593152339</a>
                          <br />
                          <a href="tel:+995595585866">+995595585866</a>
                        </div>
                      )}
                      {countryCode === "1" && (
                        <div>
                          <span>{intl.messages.phone}</span>
                          <a href="tel:+37433585850">{contactData?.phone1}</a>
                          <br />
                          <a href="tel:011585800">{contactData?.phone2}</a>
                        </div>
                      )}
                    </>
                  )}
                  {(hostName === "handle-brand.com" ||
                    hostName === "handle.am") && (
                    <>
                      {countryCode === "2" && (
                        <a href="tel:+79965377770">+79965377770</a>
                      )}
                      {countryCode === "3" && (
                        <div>
                          <span>{intl.messages.phone}</span>

                          <a href="tel:+995593152339">+995593152339</a>
                          <br />
                          <a href="tel:+995595585866">+995595585866</a>
                        </div>
                      )}
                      {(countryCode === "0" || countryCode === "1") && (
                        <div>
                          <span>{intl.messages.phone}</span>
                          <a href="tel:+37433585850">{contactData?.phone1}</a>
                          <br />
                          <a href="tel:011585800">{contactData?.phone2}</a>
                        </div>
                      )}
                    </>
                  )}
                  {hostName === "handle-brand.ru" && (
                    <>
                      {countryCode === "3" && (
                        <div>
                          <span>{intl.messages.phone}</span>

                          <a href="tel:+995593152339">+995593152339</a>
                          <br />
                          <a href="tel:+995595585866">+995595585866</a>
                        </div>
                      )}
                      {countryCode === "1" && (
                        <div>
                          <span>{intl.messages.phone}</span>
                          <a href="tel:+37433585850">{contactData?.phone1}</a>
                          <br />
                          <a href="tel:011585800">{contactData?.phone2}</a>
                        </div>
                      )}
                      {(countryCode === "0" || countryCode === "2") && (
                        <a href="tel:+79965377770">+79965377770</a>
                      )}
                    </>
                  )}
                </li>
                <li className="flex flex-ai-center">
                  <div className="icon flex flex-ai-center flex-jc-center">
                    <img
                      src={EnvelopWhiteIcon.src}
                      alt=""
                    />
                  </div>
                  {hostName === "handle.ge" && (
                    <>
                      {countryCode === "1" && (
                        <a href={`mailto:handlebrandarmenia@gmail.com`}>
                          handlebrandarmenia@gmail.com
                        </a>
                      )}
                      {countryCode === "2" && (
                        <a href="mailto:handlebrand@mail.ru">
                          handlebrand@mail.ru
                        </a>
                      )}
                      {(countryCode === "3" || countryCode === "0") && (
                        <a href="mailto:handlebrandgeorgia@gmail.com">
                          handlebrandgeorgia@gmail.com
                        </a>
                      )}
                    </>
                  )}
                  {(hostName === "handle.am" ||
                    hostName === "handle-brand.com") && (
                    <>
                      {(countryCode === "1" || countryCode === "0") && (
                        <a href={`mailto:handlebrandarmenia@gmail.com`}>
                          handlebrandarmenia@gmail.com
                        </a>
                      )}
                      {countryCode === "2" && (
                        <a href="mailto:handlebrand@mail.ru">
                          handlebrand@mail.ru
                        </a>
                      )}
                      {countryCode === "3" && (
                        <a href="mailto:handlebrandgeorgia@gmail.com">
                          handlebrandgeorgia@gmail.com
                        </a>
                      )}
                    </>
                  )}
                  {hostName === "handle-brand.ru" && (
                    <>
                      {countryCode === "1" && (
                        <a href="mailto:handlebrandarmenia@gmail.com">
                          handlebrandarmenia@gmail.com
                        </a>
                      )}
                      {(countryCode === "2" || countryCode === "0") && (
                        <a href="mailto:handlebrand@mail.ru">
                          handlebrand@mail.ru
                        </a>
                      )}
                      {countryCode === "3" && (
                        <a href="mailto:handlebrandgeorgia@gmail.com">
                          handlebrandgeorgia@gmail.com
                        </a>
                      )}
                    </>
                  )}
                </li>

                <li className="flex flex-ai-center">
                  <div className="icon flex flex-ai-center flex-jc-center">
                    <img
                      src={LocationWhiteIcon.src}
                      alt=""
                    />
                  </div>
                  <div>
                    <span>{intl.messages.ourAddress}</span>
                    {/* <>
                  </>
                  <a
                    href="https://www.google.com/maps/place/Handle+Brand/@40.1748637,44.5192301,21z/data=!4m5!3m4!1s0x406abcf14bc470ad:0xcc54b06955236c6e!8m2!3d40.1748391!4d44.5192709"
                    className="flex flex-ai-center"
                    target="_blank"
                  >
                    {contactData?.address}
                  </a> */}
                    {hostName === "handle.ge" && (
                      <>
                        {countryCode === "1" && (
                          <div className="foo-address">
                            <a
                              href="https://www.google.com/maps/place/Handle+Brand/@40.1748637,44.5192301,21z/data=!4m5!3m4!1s0x406abcf14bc470ad:0xcc54b06955236c6e!8m2!3d40.1748391!4d44.5192709"
                              className="flex flex-ai-center"
                              target="_blank"
                            >
                              {contactData?.address}
                            </a>
                          </div>
                        )}
                        {countryCode === "2" && (
                          <div className="foo-address">
                            <a
                              href="https://www.google.com/maps/place/ул.+Селезнева,+147,+Краснодар,+Краснодарский+край,+Россия,+350075/@45.0258247,39.0325156,17z/data=!3m1!4b1!4m6!3m5!1s0x40f050015c747341:0x5bd3a74027bd9ef2!8m2!3d45.0258247!4d39.0350905!16s%2Fg%2F11csfngyf8"
                              className="flex flex-ai-center"
                              target="_blank"
                            >
                              Г. Краснодар ул. Селезнева 147
                            </a>
                          </div>
                        )}
                        {(countryCode === "3" || countryCode === "0") && (
                          <div className="foo-address">
                            <a
                              href="https://www.google.com/maps/place/2+Javakheti+I+Turn,+T'bilisi,+%D0%93%D1%80%D1%83%D0%B7%D0%B8%D1%8F/@41.6920725,44.8675198,17z/data=!3m1!4b1!4m6!3m5!1s0x40440dc0424b16c5:0xd03d01db0352f799!8m2!3d41.6920725!4d44.8700947!16s%2Fg%2F11c3q22np1"
                              className="flex flex-ai-center"
                              target="_blank"
                            >
                              2 Javakheti turn, 19 building 2
                            </a>
                          </div>
                        )}
                      </>
                    )}
                    {hostName === "handle-brand.ru" && (
                      <>
                        {countryCode === "1" && (
                          <div className="foo-address">
                            <a
                              href="https://www.google.com/maps/place/Handle+Brand/@40.1748637,44.5192301,21z/data=!4m5!3m4!1s0x406abcf14bc470ad:0xcc54b06955236c6e!8m2!3d40.1748391!4d44.5192709"
                              className="flex flex-ai-center"
                              target="_blank"
                            >
                              {contactData?.address}
                            </a>
                          </div>
                        )}
                        {(countryCode === "2" || countryCode === "0") && (
                          <div className="foo-address">
                            <a
                              href="https://www.google.com/maps/place/ул.+Селезнева,+147,+Краснодар,+Краснодарский+край,+Россия,+350075/@45.0258247,39.0325156,17z/data=!3m1!4b1!4m6!3m5!1s0x40f050015c747341:0x5bd3a74027bd9ef2!8m2!3d45.0258247!4d39.0350905!16s%2Fg%2F11csfngyf8"
                              className="flex flex-ai-center"
                              target="_blank"
                            >
                              Г. Краснодар ул. Селезнева 147
                            </a>
                          </div>
                        )}
                        {countryCode === "3" && (
                          <div className="foo-address">
                            <a
                              href="https://www.google.com/maps/place/2+Javakheti+I+Turn,+T'bilisi,+%D0%93%D1%80%D1%83%D0%B7%D0%B8%D1%8F/@41.6920725,44.8675198,17z/data=!3m1!4b1!4m6!3m5!1s0x40440dc0424b16c5:0xd03d01db0352f799!8m2!3d41.6920725!4d44.8700947!16s%2Fg%2F11c3q22np1"
                              className="flex flex-ai-center"
                              target="_blank"
                            >
                              2 Javakheti turn, 19 building 2
                            </a>
                          </div>
                        )}
                      </>
                    )}
                    {(hostName === "handle-brand.com" ||
                      hostName === "handle.am") && (
                      <>
                        {(countryCode === "1" || countryCode === "0") && (
                          <div className="foo-address">
                            <a
                              href="https://www.google.com/maps/place/Handle+Brand/@40.1748637,44.5192301,21z/data=!4m5!3m4!1s0x406abcf14bc470ad:0xcc54b06955236c6e!8m2!3d40.1748391!4d44.5192709"
                              className="flex flex-ai-center"
                              target="_blank"
                            >
                              {contactData?.address}
                            </a>
                          </div>
                        )}
                        {countryCode === "2" && (
                          <div className="foo-address">
                            <a
                              href="https://www.google.com/maps/place/ул.+Селезнева,+147,+Краснодар,+Краснодарский+край,+Россия,+350075/@45.0258247,39.0325156,17z/data=!3m1!4b1!4m6!3m5!1s0x40f050015c747341:0x5bd3a74027bd9ef2!8m2!3d45.0258247!4d39.0350905!16s%2Fg%2F11csfngyf8"
                              className="flex flex-ai-center"
                              target="_blank"
                            >
                              Г. Краснодар ул. Селезнева 147
                            </a>
                          </div>
                        )}
                        {countryCode === "3" && (
                          <div className="foo-address">
                            <a
                              href="https://www.google.com/maps/place/2+Javakheti+I+Turn,+T'bilisi,+%D0%93%D1%80%D1%83%D0%B7%D0%B8%D1%8F/@41.6920725,44.8675198,17z/data=!3m1!4b1!4m6!3m5!1s0x40440dc0424b16c5:0xd03d01db0352f799!8m2!3d41.6920725!4d44.8700947!16s%2Fg%2F11c3q22np1"
                              className="flex flex-ai-center"
                              target="_blank"
                            >
                              2 Javakheti turn, 19 building 2
                            </a>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </li>
              </ul>
            </div>
            <div className="contact-image">
              <SimpleSlider />
            </div>
          </div>
        </div>
        {/* {hostName !== "handle.ge" && (
        <div className="map">
          <YandexMap />
        </div>
      )} */}
        <div className="map">
          <MapComponent />
        </div>
        <div className="wrapper">
          <div className="contact-form">
            <h6>{intl.messages.contactWithUs}</h6>
            <div className="flex">
              <label
                htmlFor="name"
                className="mr-20"
              >
                <span>{intl.messages.yourName} *</span>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={state.name}
                  onChange={handleChange}
                />
                {nameError && <span className="error">{nameError}</span>}
              </label>
              <label
                htmlFor="phone"
                className="mr-20"
              >
                <span>{intl.messages.yourPhone} *</span>
                <input
                  type="text"
                  id="phone"
                  name="phone"
                  value={state.phone}
                  onChange={handleChange}
                />
                {phoneError && <span className="error">{phoneError}</span>}
              </label>
              <label htmlFor="email">
                <span>{intl.messages.yourEmail} *</span>
                <input
                  type="text"
                  id="email"
                  name="email"
                  value={state.email}
                  onChange={handleChange}
                />
                {error && <span className="error">{error}</span>}
              </label>
            </div>
            <label htmlFor="message">
              <span>{intl.messages.yourMessage} *</span>
              <textarea
                id="message"
                cols="30"
                rows="10"
                name="description"
                value={state.description}
                onChange={handleChange}
              />
              {descriptionError && (
                <span className="error">{descriptionError}</span>
              )}
            </label>

            <div
              className="flex flex-jc-end"
              onClick={addContacts}
            >
              <button>{intl.messages.send}</button>
            </div>
          </div>
        </div>
        <Popup trigger={successSave}>
          {successSave && (
            <>
              <button
                className="close-button"
                onClick={closeSuccessPopup}
              >
                <img
                  src={CloseDarkIcon.src}
                  alt=""
                />
              </button>
              <div className="popup-body">
                <div className="popup-message">
                  <h4>
                    <img
                      src={CheckGreenIcon.src}
                      alt=""
                    />
                    Your message has been successfully sent.
                  </h4>
                </div>
                <div className="popup-buttons">
                  <button onClick={closeSuccessPopup}>Close</button>
                </div>
              </div>
            </>
          )}
        </Popup>
      </div>
    </>
  );
};

export default Contact;
